module.exports = __webpack_public_path__ + "img/banner-480.42aba00d.png";